function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.337891 12.0088H1.8833V13.2905H2.71094V12.0088H3.76562V13.2905H4.58594V11.9941C6.52686 11.8696 7.66211 10.8296 7.66211 9.15967V9.14502C7.66211 7.82666 6.76123 6.87451 5.3623 6.7207V6.66211C6.38037 6.48633 7.16406 5.52686 7.16406 4.4502V4.43555C7.16406 3.02197 6.16064 2.04785 4.58594 1.90137V0.597656H3.76562V1.87939H2.71094V0.597656H1.8833V1.87939H0.337891V12.0088ZM1.94189 6.21533V3.19775H3.7583C4.92285 3.19775 5.56738 3.71777 5.56738 4.64795V4.6626C5.56738 5.66602 4.82031 6.21533 3.42871 6.21533H1.94189ZM1.94189 10.6904V7.46777H3.74365C5.28906 7.46777 6.00684 7.98047 6.00684 9.0498V9.06445C6.00684 10.1411 5.29639 10.6904 3.83887 10.6904H1.94189Z",
  fill: "#8E8E93"
});

function SvgBitcoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.38936f35.svg";
export { ForwardRef as ReactComponent };